<template>
  <div class="market-segments">
    <div class="pd-t30 pd-b50">
      <div class="mg-b20">
        <img class="max-w100p" :src="publicPath + 'static/images/business/market_segments/market_segments_01.jpg'"
             alt="">
      </div>
      <div class="description details-box">
        <p class="f16">专业引领、深耕细作。和德经纪在现有市场环境中寻求适合自身的独特发展方向，选择某一细分领域，通过持续的经验积累和精耕细作，不断完善在该领域的经营模式，以期形成难以复制的独特商业模式和可持续的市场竞争力，为客户提供优质的服务方案。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "market-segments"
}
</script>

<style>

</style>